import React from 'react';
import loadable from '@loadable/component';
import type { AllFiltersProps } from './types';

const AllFilters = loadable(
  () => import(/* webpackChunkName: "product-page-filters" */ './all-filters')
);

export const AllFiltersLoader = (props: AllFiltersProps) => (
  <AllFilters {...props} />
);
